module.exports = __webpack_public_path__ + "static/media/watchMovie.c00efaef.svg";